import { createSlice } from "@reduxjs/toolkit";

export const initialSaleLocalState = {
  minimum_profit_level: "",
  minimum_profit_level_message: "Warning Profit is below minimum",
  is_minimum_profit_required: false,
  quote_expiry_days: "",
};

export const saleSlice = createSlice({
  name: "sale",
  initialState: {
    sales: [],
    isAddSaleSuccess: false,
    isAddSaleFailedResponse: false,
    newSaleLocal: initialSaleLocalState,
  },

  reducers: {
    getAllSaleAction: (state) => {},
    setAllSaleAction: (state, { payload }) => {
      state.sales = payload;
    },

    addSaleAction: (state, { payload }) => {},
    setAddSaleResponse: (state, { payload }) => {
      state.isAddSaleSuccess = payload;
    },
    updateSaleAction: (state, { payload }) => {},
    updateSaleResponse: (state, { payload }) => {
      state.isAddSaleSuccess = payload;
    },

    deleteSaleAction: (state, { payload }) => {},

    updateSingleWorkerAction: (state, { payload }) => {},

    updateSaleError: (state, { payload }) => {
      state.isAddSaleFailedResponse = payload;
    },

    getAllSaleById: (state, { payload }) => {},
    setNewSaleLocal: (state, action) => {
      state.newSaleLocal = {
        ...state.newSaleLocal,
        ...action.payload,
      };
    },

    resetNewSaleLocal: (state) => {
      state.newSaleLocal = initialSaleLocalState;
    },
  },
});

const {
  getAllSaleAction,
  setAllSaleAction,
  addSaleAction,
  setAddSaleResponse,
  updateSaleAction,
  updateSaleResponse,
  updateSingleWorkerAction,
  updateSaleError,
  deleteSaleAction,
  getAllSaleById,
  setNewSaleLocal,
  resetNewSaleLocal,
} = saleSlice.actions;

export {
  getAllSaleAction,
  setAllSaleAction,
  addSaleAction,
  setAddSaleResponse,
  updateSaleAction,
  updateSaleResponse,
  updateSingleWorkerAction,
  updateSaleError,
  deleteSaleAction,
  getAllSaleById,
  setNewSaleLocal,
  resetNewSaleLocal,
};

export default saleSlice.reducer;